import { configureStore, combineReducers, AnyAction } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import loginSlice from '../slices/LoginSlice';
import authorizationSlice from '../slices/AuthorizationSlice';
import themeSlice from '../slices/ThemeSlice';
import logoutSlice from '../slices/LogoutSlice';
import schoolConfigSlice from '../slices/SchoolConfigSlice';
import routes from '../../constants/routes';
import authenticationUtils from '../../utils/authenticationUtils';
import profileSlice from '../slices/ProfileSlice';
import schoolSlice from '../slices/School';
import paymentUserSlice from '../slices/PaymentUserSlice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['profile', 'paymentUser']
};

export const appReducer = combineReducers({
  login: loginSlice.reducer,
  authorization: authorizationSlice.reducer,
  theme: themeSlice.reducer,
  profile: profileSlice.reducer,
  logoutSlice: logoutSlice.reducer,
  schoolConfig: schoolConfigSlice.reducer,
  school: schoolSlice.reducer,
  paymentUser: paymentUserSlice.reducer
});

const rootReducer = (state: RootState | undefined, action: AnyAction): any => {
  if (action.type === 'authorize/logoutAdmin/fulfilled') {
    authenticationUtils.clearStorage();
    window.location.href = routes.ADMIN_LOGIN;
    // navigate.push(routes.ADMIN_LOGIN);
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

const persistedReducer: any = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
